export default {"src":"/_next/static/media/favicon.eb34ed02.svg","height":59,"width":59,"blurWidth":0,"blurHeight":0};